
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bridge",
      function () {
        return require("private-next-pages/bridge/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bridge"])
      });
    }
  